import {z} from 'zod';
import type {ObjectTypeField} from '@/matic/features/master-data/types/master-data-types';

/**
 * Build a Zod schema from an ObjectType's active fields.
 *
 * Required fields get a refinement that rejects null, undefined, empty
 * strings, and empty arrays. Optional fields are `z.unknown().optional()`.
 * The returned schema uses `.passthrough()` so extra keys (e.g. a
 * pre-filled reference field) are preserved.
 */
export function buildDynamicSchema(activeFields: ObjectTypeField[]) {
  const shape: Record<string, z.ZodTypeAny> = {};
  for (const field of activeFields) {
    if (field.required) {
      shape[field.fieldKey] = z
        .unknown()
        .refine(
          (val) =>
            val !== null &&
            val !== undefined &&
            val !== '' &&
            !(Array.isArray(val) && val.length === 0),
          {message: `${field.label} is required`}
        );
    } else {
      shape[field.fieldKey] = z.unknown().optional();
    }
  }

  return z.object(shape).passthrough();
}
